import { supabase } from './supabaseClient';

// The shared ingredient library. One entry per raw material, priced once and
// referenced by every formula that uses it — pricing the same shea butter
// separately inside each formula is how the costs drifted (and how they all
// ended up empty).

export async function listIngredients() {
  const { data, error } = await supabase.from('ingredients').select('*').order('name');
  if (error) throw error;
  return data;
}

export async function addIngredient(fields) {
  const { data, error } = await supabase.from('ingredients').insert(fields).select().single();
  if (error) throw error;
  return data;
}

export async function updateIngredient(id, updates) {
  const { data, error } = await supabase
    .from('ingredients')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteIngredient(id) {
  const { error } = await supabase.from('ingredients').delete().eq('id', id);
  if (error) throw error;
}

// Used by the formula editor's ingredient picker: typing a name with no match
// offers to create it, the same pattern VendorAutocomplete uses.
export async function findOrCreateIngredient(name, existing) {
  const match = existing.find((i) => i.name.toLowerCase() === name.trim().toLowerCase());
  if (match) return match;
  return addIngredient({ name: name.trim() });
}

export function isPriced(ingredient) {
  return ingredient?.cost_per_kg != null && Number(ingredient.cost_per_kg) > 0;
}
